import React, {useContext, FC, useState, useEffect} from "react"
import {ThemeContext, ThemeProvider as OGTheme} from "styled-components"
import type {DefaultTheme} from "styled-components"
import mainTheme from "../theme"
import updateBranding from "./branding"

export const useTheme = (): DefaultTheme => {
  const theme = useContext(ThemeContext)
  if (!theme) {
    throw new Error("useTheme must be used within a ThemeProvider")
  }
  return theme
}

export const ThemeProvider: FC<{children: React.ReactNode}> = ({children}) => {
  const [theme, setTheme] = useState(mainTheme)

  useEffect(() => {
    setTimeout(() => updateBranding(setTheme))
  }, [])

  return <OGTheme theme={theme}>{children}</OGTheme>
}
